export default __webpack_public_path__ + "static/24-30a42921868a5a3b67306712572edf87.jpg";